import axiosInstance from "../../lib/axiosInstance"
import { AuthTokenManager } from "../../helpers/commonUtills"
import {
  dashboardReportListFailure,
  dashboardReportListRequest,
  dashboardReportListSuccess,
  editDashboardReportFailure,
  editDashboardReportRequest,
  postDashboardReportFailure,
  postDashboardReportRequest,
} from "./dashboardListActions"
import constants from "../../helpers/en.js"
import {
  CLEAR_DS_REPORT_DATA,
  SET_ACTIVE_DASH_NAVLINK,
  SET_DS_REPORT_DATA,
} from "./actionTypes.js"
import { handleApiError } from "../../utils/errorUtils.js"

// Toast helpers — toast is a React ref ({ current: { showSuccess, showWarn, showError } })
const toastSuccess = (toast, msg) => toast?.current?.showSuccess(msg)

const toastWarn = (toast, msg) => toast?.current?.showWarn(msg)

const toastError = (toast, msg) => toast?.current?.showError(msg)

const authHeaders = () => {
  const t = AuthTokenManager.get()
  return t ? { Authorization: `Bearer ${t}` } : {}
}

//GET DASHBOARD REPORTS
export const getDashboardReportsList = (
  pageType,
  selectedClientId,
  selectedFacilityId,
  toastRef,
  userType,
) => {
  return async (dispatch) => {
    if (!selectedClientId || !pageType) return

    dispatch(dashboardReportListRequest())

    try {
      // ✅ Build query dynamically
      const queryParams = new URLSearchParams({
        page_type: pageType,
        facility_account_no: selectedClientId,
        userType,
      })

      if (selectedFacilityId) {
        queryParams.append("worksite_account_no", selectedFacilityId)
      }
      const response = await axiosInstance.get(
        `/api/dashboard?${queryParams}`,
        { headers: authHeaders() },
      )

      dispatch(dashboardReportListSuccess(response.data))

      if (response.data === "No records found") {
        toastWarn(toastRef, constants.NO_RECORDS_FOUND)
      }
    } catch (error) {
      // ✅ Centralized error handling (kept handleApiError)
      handleApiError(error, toastRef)
      dispatch(dashboardReportListFailure(error.message))
    }
  }
}

//ADD DASHBOARD REPORTS
export const addDashboardReports =
  (dashboardReportPayload, toastRef, navigateBack) => async (dispatch) => {
    dispatch(postDashboardReportRequest())
    try {
      const { status } = await axiosInstance.post(
        `/api/dashboard`,
        dashboardReportPayload,
        { headers: authHeaders() },
      )

      if (status === 200) {
        toastSuccess(toastRef, constants.REPORT_SUBMITTED_SUCCESSFULLY)

        setTimeout(() => navigateBack(), 500)
      } else {
        toastError(toastRef, constants.REPORT_SUBMISSION_FAILED)
        dispatch(postDashboardReportFailure(constants.REPORT_SUBMISSION_FAILED))
      }
    } catch (error) {
      handleApiError(error, toastRef)
      dispatch(postDashboardReportFailure(error.message || "Unknown Error"))
    }
  }

//EDIT DASHBOARD REPORTS
export const editDashboardReports =
  (dashboardReportPayload, toastRef, navigateBack) => async (dispatch) => {
    dispatch(editDashboardReportRequest())
    try {
      const { status } = await axiosInstance.patch(
        `/api/dashboard`,
        dashboardReportPayload,
        { headers: authHeaders() },
      )

      if (status === 200) {
        toastSuccess(toastRef, constants.REPORT_UPDATED_SUCCESSFULLY)

        setTimeout(() => navigateBack(), 800)
      } else {
        toastError(toastRef, constants.REPORT_UPDATION_FAILED)
        dispatch(editDashboardReportFailure(constants.REPORT_UPDATION_FAILED))
      }
    } catch (error) {
      handleApiError(error, toastRef)
      dispatch(editDashboardReportFailure(error.message || "Unknown Error"))
    }
  }

export const activateReport = (statusType, dsId, refreshReports, toastRef) => {
  const newStatus = !statusType
  const UserPayload = { dashboard_id: dsId, is_active: newStatus }

  return (dispatch) => {
    return axiosInstance
      .patch(`/api/dashboard`, UserPayload, { headers: authHeaders() })
      .then((response) => {
        if (response?.status === 200) {
          refreshReports()
        }
      })
      .catch((error) => {
        handleApiError(error, toastRef)
      })
  }
}

export const setActiveDashNavLink = (link) => ({
  type: SET_ACTIVE_DASH_NAVLINK,
  payload: link,
})

//FACILITY ADMIN DASHBOARD REPORT
export const setDsReportData = (data) => ({
  type: SET_DS_REPORT_DATA,
  payload: data,
})

// Action to clear object data
export const clearDsReportData = () => ({
  type: CLEAR_DS_REPORT_DATA,
})
